<script>
    import { onMount } from "svelte";
    import SvelteTable from "../../../../Components/Common/SvelteTable.svelte";
    import { getFormatBirthDate, getFormatDateAndTime, getGenderType, getInsuranceType, getText, getTitle, isObjectEmpty, showError } from "../../../../Utils/utilFunctions.svelte";
    import { insuranceFund } from "../../../../stores";
    import { cacheInsuranceFunds } from "../../../../Utils/utilCache.svelte";

    export let 
        matchResult = {},
        onApplyMatch;

    let scrollTableContainerRef;

    const columns = [
        {
            key: "patientFullName",
            title: "Patient Name",
            headerClass: "text-left pl-3",
            class: "px-3 text-left",
            renderValue: (v) => _getName(v.patient),
        },
        {
            key: "dateOfBirth",
            title: "Date of Birth",
            headerClass: "text-left pl-3 ",
            class: "px-3 text-left",
            renderValue: (v) => getFormatBirthDate(v.patient.birthDate),
        },
      /*    {
            key: "gender",
            title: "Gender",
            headerClass: "text-left pl-3",
            class: "px-3 text-left",
            renderValue: (v) => getGenderType(v.patient.sex),
        }, */
        {
            key: "createdDate",
            title: "Created date",
            headerClass: "text-left pl-3",
            class: "px-3 text-left",
            renderValue: (v) => getFormatDateAndTime(v.createdDate),
        },
        {
            key: "insuranceType",
            title: "Insurance Type",
            headerClass: "text-left pl-3",
            class: "px-3 text-left",
            renderValue: (v) => _getInsuranceType(v.patient),
        },
        {
            key: "details",
            title: "Details",
            headerClass: "text-left pl-3",
            class: "px-3 text-left",
            renderValue: (v) => _getFundName(v.patient.insuranceId),
        },
        {
            key: "doctor",
            title: "Doctor",
            headerClass: "text-left pl-3",
            class: "px-3 text-left",
            renderValue: (v) => _getDoctorName(v.doctor),
        },
        {
            key: "email",
            title: "Email",
            headerClass: "text-left pl-3",
            class: "px-3 text-left",
            renderValue: (v) => getText(v.patient.email),
        },
        {
            key: "phone",
            title: "Phone",
            headerClass: "text-left pl-3",
            class: "px-3 text-left",
            renderValue: (v) => getText(v.patient.phone),
        },
        {
            key: "buttons",
            title: "Actions",
            headerClass: "text-left pl-3 cursor-default rounded-tr-xl",
            class: "px-3 cursor-pointer",
            renderValue: (v) => _renderSelectColumn(v),
        },
        
    ];
   
    onMount(async () => {
        if (!$insuranceFund?.length) await cacheInsuranceFunds();

        if (privateHealthFundId) {
            const targetFund = $insuranceFund.find(
                (fund) => fund.id == privateHealthFundId,
            );

            if (targetFund) privateHealthFundName = targetFund.name;
        }
    });

    const _getName = ({ firstName, lastName, title, middleName }) => {
        const name = `${firstName}${
            middleName ? " " + middleName : ""
        } ${lastName}`;
        return `${getTitle(title)} ${name}`;
    };

    const _getFundName = (privateHealthFundId) => {
        if (privateHealthFundId && $insuranceFund.length) {
            const targetFund = $insuranceFund.find(
                (fund) => fund.id == privateHealthFundId,
            );

            if (targetFund) return targetFund.name;
        }
        return "";
    }

    const _getInsuranceType = (patient = {}) => {
        if (isObjectEmpty(patient)) return "-";
        const { insuranceType } = patient;
        return getInsuranceType(insuranceType);
    };

    const _getDoctorName = (doctor = {}) => {
        if (isObjectEmpty(doctor)) return "-";
        const { fullName } = doctor;
        return fullName;
    };

    const _renderSelectColumn = (v) => {
        return `
            <div class="flex flex-1 items-center justify-start gap-x-2">
                <button
                    class="applyBtn-${v.id} btn btn-secondary btn-sm"
                >
                    Apply
                </button>
            </div>
        `;
    };

    const handleClickCell = ({ target: { className } }, rowData, key) => {
        if (key == "buttons") {
            const classArr = className.split(" ");
            if (className.includes("applyBtn")) {
                const targetClass = classArr.find((cls) =>
                    cls.includes("applyBtn"),
                );
                const encounterId = targetClass.replace("applyBtn-", "");
                try {
                    const id = parseInt(encounterId);
                    var encounter = matchResult.results.find(r => r.id == id);
                    if(encounter){
                        onApplyMatch(encounter);
                    }
                }
                catch(e){
                    showError("Error occured trying to apply patient details");
                }
                
            }
           
        } 
    };


</script>

<div
    class={"overflow-y-auto"}
    bind:this={scrollTableContainerRef}
>
    <SvelteTable
        {columns}
        rows={matchResult.results}
        customRow={`cursor-pointer`}
        clickCellFunc={({ detail: { event, row, key } }) => {
            handleClickCell(event, row, key);
        }}
    />
</div>

<style>

</style>
